import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_CONTRACTOR_INVOICES';

export async function getAllContractorInvoices(
    userToken: string,
    query?: string
) {
    try {
         

        const response = await axios.get(
             
            `${URL}/contractor-invoices/?${query}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de récuperation de la liste des factures fournisseurs',
            error: error
        });
    }
}
